import {diApi} from '@di-shared/api/di';
import {parseDateWithFormat} from '@shared/dateUtils';
import {getQueryKey} from '@shared/queryKeyMap';
import {useSuspenseQuery} from '@tanstack/react-query';

export enum MileageRegisterCase {
  /**
   * 1-1
   * 4.1.8 vhcleLink 사진등록요청일자-1일자의 최종 누적주행거리
   * 01 전송필요 / 03 불필요
   */
  CASE1_1,
  /**
   * 1-2
   * 4.1.9 seasonLink 3/31의 최종 누적주행거리 전송
   * 02 불필요 / 02 종료 등록 필요
   */
  CASE1_2,
}

function getMileageRegisterCase({drvngRgsYn}: {drvngRgsYn: string}) {
  if (drvngRgsYn === '01') {
    return MileageRegisterCase.CASE1_1;
  }
  if (drvngRgsYn === '02') {
    return MileageRegisterCase.CASE1_2;
  }
  return MileageRegisterCase.CASE1_1;
}

function useMileageRegister(vin: string) {
  const {
    data: {drvng_dstnc_rgsde: drvngDstncRgsde, drvng_dstnc_endde: drvngDstncEndde, drvng_rgs_yn: drvngRgsYn, drvng_stt_cd},
  } = useSuspenseQuery({
    queryKey: [getQueryKey(diApi.ecoMileageController.getInfoLink)],
    queryFn: () =>
      diApi.ecoMileageController.getInfoLink({
        vin,
      }),
    select: (data) => data.data.rtn_data,
  });

  const mileageRegisterCase = getMileageRegisterCase({drvngRgsYn});

  return {
    mileageRegisterCase,
    drvngDstncRgsde: parseDateWithFormat(drvngDstncRgsde),
    drvngDstncEndde: parseDateWithFormat(drvngDstncEndde),
    drvng_stt_cd,
  };
}

export default useMileageRegister;
